module.exports = __webpack_public_path__ + "img/Suporte_tecnico.1f68f93.svg";